import {getField, updateField} from 'vuex-map-fields'

const state = {
  developerMode: false,
  dark: false,
  replaceTabNext: false,
  mainNavDrawer: true,
  floatingTabs: false,
  pageLoading: false,
  haveNotification: false,
  globalAlert: {
    type: '',
    title: '',
    message: '',
  },
  globalAlertActivate: false,
  globalOperation: {
    title: '',
    icon: '',
    iconColor: '',
    text: '',
    subText: '',
    disableCancel: false,
    disableConfirm: false,
    cancelText: '取消',
    confirmText: '确认',
    width: '350px',
    onCancel: undefined,
    onConfirm: undefined,
  },
  globalOperationActivate: false,
  // bcItems: []
}
const getters = {
  getField,
}
const actions = {}
const mutations = {
  updateField,
  setDark (state, val) {
    state.dark = val
  },
  setPageLoading (state, val) {
    state.pageLoading = !!val
  },
  routerInTab (state) {
    state.replaceTabNext = true
  },
  openAlert (state, {type = '', title = '', message = ''}) {
    state.globalAlert = {
      type: type,
      title: title,
      message: message,
    }
    state.globalAlertActivate = true
  },
  closeAlert (state) {
    state.globalAlert = {
      type: '',
      title: '',
      message: '',
    }
    state.globalAlertActivate = false
  },
  openOperation (state, attr) {
    state.globalOperation = {
      title: attr.title || '',
      icon: attr.icon || '',
      iconColor: attr.iconColor || '',
      text: attr.text || '',
      subText: attr.subText || '',
      disableCancel: attr.disableCancel || false,
      disableConfirm: attr.disableConfirm || false,
      cancelText: attr.cancelText || '取消',
      confirmText: attr.confirmText || '确认',
      width: attr.width || '350px',
      onCancel: attr.onCancel,
      onConfirm: attr.onConfirm,
    }
    state.globalOperationActivate = true
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
